module.exports = "/images/Denmark.png?7badff205197e5c3be11406b8550f7b5";